const dateOptions = [ "Today", "Tomorrow", "Next Week", "Pick a Date" ];

export { dateOptions };